import { ALL_MONTHS } from "./constants";

export const toN = (v) => v===""||v==null ? 0 : Number(String(v).replace(/[^0-9-]/g,""))||0;
export const parseTSV = (text) => text.trim().split(/\r?\n/).map(r=>r.split("\t").map(c=>c.trim()));
export const getMonths = (sm) => [...ALL_MONTHS.slice(sm-1), ...ALL_MONTHS.slice(0,sm-1)];
export const mkMap = (months, val=0) => Object.fromEntries(months.map(m=>[m,val]));

export const makeId = (prefix="id") => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}_${crypto.randomUUID()}`;
  }
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2,10)}`;
};

export const normalizeKey = (s) => String(s ?? "").replace(/[\s　]+/g, "").trim().toLowerCase();
export const isMonthLike = (s) => /^(\d{1,2})月$/.test(String(s ?? "").trim()) || /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)$/i.test(String(s ?? "").trim());

export const findIndexByName = (rows, name, fallbackIndex = -1) => {
  const key = normalizeKey(name);
  if (key) {
    const hit = rows.findIndex(r => normalizeKey(r.name) === key);
    if (hit >= 0) return hit;
  }
  return fallbackIndex >= 0 && fallbackIndex < rows.length ? fallbackIndex : -1;
};

export function getMonthStatusLabel(hasRev, hasExp) {
  if (!hasRev && !hasExp) return { label:"未入力", bg:"#F3F4F6", color:"#666" };
  if (hasRev && hasExp) return { label:"入力済み", bg:"#E8F4E8", color:"#2D7A2D" };
  return { label:"一部入力", bg:"#FFF3DC", color:"#AA7722" };
}

export function fmtDiff(diff, positiveIsGood = true) {
  if (diff == null) return null;
  const good = positiveIsGood ? diff >= 0 : diff <= 0;
  const sign = diff >= 0 ? "+" : "−";
  return { text: `${sign}${Math.abs(diff).toLocaleString()}`, color: good ? "#2D7A2D" : "#C0392B" };
}

export function normalizeSimpleActuals(simple, months) {
  const src = simple || {};
  const migratedRevItems = src.revItems && src.revItems.length
    ? src.revItems.map(item => ({
        id: item.id || makeId("simpleRev"),
        name: item.name || "売上項目",
        monthly: Object.fromEntries(months.map(m => [m, item.monthly?.[m] ?? ""])),
      }))
    : [{ id: makeId("simpleRev"), name: "売上合計", monthly: Object.fromEntries(months.map(m => [m, src.rev?.[m] ?? ""])) }];
  const migratedExpItems = src.expItems && src.expItems.length
    ? src.expItems.map(item => ({
        id: item.id || makeId("simpleExp"),
        name: item.name || "費用項目",
        monthly: Object.fromEntries(months.map(m => [m, item.monthly?.[m] ?? ""])),
      }))
    : [{ id: makeId("simpleExp"), name: "費用合計", monthly: Object.fromEntries(months.map(m => [m, src.exp?.[m] ?? ""])) }];

  const rev = Object.fromEntries(months.map(m => [m,
    migratedRevItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0)
      ? String(migratedRevItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0))
      : migratedRevItems.some(item => (item.monthly?.[m] ?? "") !== "")
        ? String(migratedRevItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0))
        : ""
  ]));
  const exp = Object.fromEntries(months.map(m => [m,
    migratedExpItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0)
      ? String(migratedExpItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0))
      : migratedExpItems.some(item => (item.monthly?.[m] ?? "") !== "")
        ? String(migratedExpItems.reduce((s, item) => s + toN(item.monthly?.[m]), 0))
        : ""
  ]));

  return { ...src, revItems: migratedRevItems, expItems: migratedExpItems, rev, exp };
}
